/**
 * After switching shops, entity URLs (funnel id, ad account, etc.) often 404
 * because they belong to the previous shop. Map those to a safe parent route;
 * leave shop-agnostic list/settings pages alone.
 */
const ENTITY_ROUTE_FALLBACKS: Array<{
  test: RegExp;
  fallback: string;
}> = [
  { test: /^\/editor\/[^/]+/, fallback: "/funnels" },
  { test: /^\/studio\/[^/]+/, fallback: "/funnels" },
  { test: /^\/funnels\/[^/]+/, fallback: "/funnels" },
  { test: /^\/ad-accounts\/[^/]+/, fallback: "/ad-accounts" },
  { test: /^\/experiments\/[^/]+/, fallback: "/experiments" },
  { test: /^\/ai\/[^/]+$/, fallback: "/ai" },
  {
    test: /^\/ai-discovery\/prompts\/[^/]+/,
    fallback: "/ai-discovery/prompts",
  },
  { test: /^\/create\//, fallback: "/funnels" },
];

export function getPostShopSwitchPath(pathname: string): string {
  const path = pathname.split("?")[0] ?? pathname;

  for (const { test, fallback } of ENTITY_ROUTE_FALLBACKS) {
    if (test.test(path)) return fallback;
  }

  return path || "/home";
}
